export const environment = {
  production: true,
  version: 'v1',
  facade: 'admin',
  getApiPath: (endpoint) => `/api/${environment.version}/${environment.facade}/${endpoint}`,
  defaultLang: 'en', // en, zh_hk, zh_cn
  refreshJwtTimeFrame: 5, // minutes to refresh jwt before it expires
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts